<template>
  <div id="RelatedContentList">
    <div class="slick-container">
      <slick ref="slickRef" class="slick-class" :options="slickOptions">
        <button
          v-for="(videoData, index) in videoArray"
          :key="index"
          @click="openVideoModal(videoData)"
          class="video-button"
        >
          <div v-html="videoData.embed.replace(/(title=0&amp;)/, '$1controls=0&amp;')" class="video-container"></div>
          <p class="video-duration">{{ videoData.duration }}</p>
          <h4 class="video-title">{{ videoData.title }}</h4>
        </button>
      </slick>
    </div>
  </div>
</template>

<script>
import slick from "vue-slick";
import VideoModal from "./VideoModal.vue";

export default {
  name: "RelatedContentList",
  props: ["videoArray"],
  components: {
    slick,
    VideoModal
  },
  data() {
    return {
      slickOptions: {
        infinite: false,
        nextArrow: `<button type="button" class="slick-next"><i class="fa fa-caret-right" aria-hidden="true"></i></button>`,
        prevArrow: `<button type="button" class="slick-prev"><i class="fa fa-caret-left" aria-hidden="true"></i></button>`,
        slidesToScroll: 2,
        slidesToShow: 2,
        responsive: [
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },
  computed: {
    passedAreaId() {
      return this.$route.params.areaId;
    },
    passedServiceId() {
      return this.$route.params.serviceId;
    }
  },
  methods: {
    openVideoModal(videoData) {
      const content = this.$createElement(VideoModal, { props: { videoData } });
      let opts = {
        hideHeader: true,
        hideFooter: true,
        size: "md",
        buttonSize: "sm",
        centered: true,
        id: "video_modal"
      };
      return this.$bvModal.msgBoxOk(content, opts);
    }
  }
};
</script>

<style lang="less">
#RelatedContentList {
  .video-button {
    position: relative;
    max-width: 220px;
    background-color: unset;
    border: 0;
    padding: 0;
  }

  .video-container {
    position: relative;
    max-width: 100%;

    iframe {
      max-width: 220px;
      pointer-events: none;
    }

    iframe,
    .VideoThumbnail_module_videoThumbnail__d1b35579,
    .player.right-content-area-supported > .content-area-sibling-enabled {
      position: static !important;
    }
  }

  .video-duration {
    position: absolute;
    top: 95px;
    right: 8px;
    font-family: "PlusJakartaSansBold";
    border-radius: 8px;
    background-color: rgba(30, 30, 34, 0.4);
    backdrop-filter: blur(20px);
    padding: 4px 8px;
    color: #fff;
    text-align: center;
    font-size: 1.2rem;
    line-height: 2rem;
  }

  .video-title {
    text-align: left;
    font-family: "PlusJakartaSansBold";
    color: #0f152e;
    font-size: 1.6rem;
    line-height: 2.2rem;
    margin: 0;
  }

  .slick-container {
    width: 100%;
    max-width: 616px;
  }

  .slick-slider {
    position: relative;
  }

  .slick-track {
    margin-left: 0;
  }

  .slick-next,
  .slick-prev {
    position: absolute;
    z-index: 10;
    top: 50%;
    background-color: transparent;
    border: none;
    padding: 0 6px;
    transform: translateY(-50%);

    .fa {
      font-size: 3rem;
      color: #1e1e22;
    }
  }

  .slick-next {
    right: -20px;
  }

  .slick-prev {
    left: -20px;
  }

  .slick-slide {
    margin: 0 16px 0 4px;
  }

  .slick-disabled {
    display: none !important;
  }
}
</style>
